export const LS_KEY = 'feedback-modal-showed';
